import { Component, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';

import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';

import { filter } from 'rxjs/operators';

import { AuthService, ConfigService } from './core/services';
import { TopAlertComponent, LoaderComponent, BigDotsSpinnerComponent } from './shared/components';
import { SupportedLanguageCodes } from './static-data/languages';
import * as ConfigActions from './store/config/config.actions';
import { LoadPrismicData } from './store/prismic/prismic.actions';
import * as fromRoot from './store/reducers';

Window.prototype['setScopes'] = (...scopes) => {
  const userState = JSON.parse(localStorage.getItem('userState'));
  userState.user.scopes = [...scopes];
  localStorage.setItem('userState', JSON.stringify(userState));
  location.reload();
};
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet, TopAlertComponent, BigDotsSpinnerComponent, LoaderComponent],
})
export class AppComponent implements OnInit {
  private _authService = inject(AuthService);
  private _configService = inject(ConfigService);
  private _router = inject(Router);
  private _store = inject<Store<fromRoot.State>>(Store);
  private _titleService = inject(Title);
  private _translate = inject(TranslateService);

  initialLoading = toSignal(this._configService.initialLoading$);
  constructor() {
    let languageCode = localStorage.getItem('languageCode') || SupportedLanguageCodes.EnglishCA;

    this._translate.use(languageCode);

    this._router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed()
      )
      .subscribe(() => {
        languageCode = localStorage.getItem('languageCode');
        if (this._translate.currentLang && this._translate.currentLang !== languageCode) {
          this._translate.use(languageCode);
          // For cases when currentLang is not defined yet, happens on page refresh
        } else if (!this._translate.currentLang) {
          setTimeout(() => this._translate.use(languageCode));
        }
      });
  }

  ngOnInit(): void {
    this._authService.initIdpSessionVisibilityListener();
    this._configService.initialLoadingStart();
    localStorage.setItem('domain', this._configService.appIdentifier);
    // set base-href to Store/LocalStorage
    this._store.dispatch(new ConfigActions.GetInitialLayoutAction(this._configService.appIdentifier));
    this._setFavicon(this._configService.appIdentifier);
    this._setTitle(this._configService.appIdentifier);

    this._store.dispatch(new LoadPrismicData());
  }

  private _setFavicon(domain: string): void {
    const favIcon: HTMLLinkElement = document.querySelector('#metaFavicon');
    favIcon.href = `/assets/favicons/Favicon_${domain}.png`;
  }

  private _setTitle(domain: string): void {
    let title = '';
    switch (domain) {
      case 'youroneprotectcom':
        title = 'One Protect';
        break;
      case 'primeautomotiveprotectcom':
        title = 'Prime Automotive Protect';
        break;
      case 'mppdealerportalcom':
        title = 'Mazda Protection Products';
        break;
      case 'miniprotectioncom':
        title = 'Mini Protection';
        break;
      case 'bmwprotectioncom':
        title = 'BMW Protection';
        break;
    }
    this._titleService.setTitle(title);
  }
}
